import { Builder } from "@builder.io/react";
import { AVATAR_SIZES } from "@faire/slate/private/avatar/consts";

import { BuilderAvatar } from "./BuilderAvatar";
import { BuilderIconConfig } from "./BuilderIconConfig";

export const registerBuilderAvatar = () => {
  Builder.registerComponent(BuilderAvatar, {
    name: "Avatar",
    hideFromInsertMenu: false,
    // to make sure avatar is not wrapped in a div
    noWrap: true,
    canHaveChildren: false,
    inputs: [
      {
        name: "borderColor",
        type: "color",
      },
      {
        name: "label",
        type: "string",
      },
      {
        name: "image",
        type: "object",
        subFields: [
          {
            name: "url",
            type: "file",
          },
          {
            name: "alt_text",
            type: "string",
          },
        ],
      },
      {
        name: "size",
        type: "object",
        subFields: [
          {
            name: "mobileAndAbove",
            type: "string",
            enum: AVATAR_SIZES,
            defaultValue: "medium",
          },
          {
            name: "tabletAndAbove",
            type: "string",
            enum: AVATAR_SIZES,
          },
          {
            name: "desktopAndAbove",
            type: "string",
            enum: AVATAR_SIZES,
          },
          {
            name: "xLargeAndAbove",
            type: "string",
            enum: AVATAR_SIZES,
          },
          {
            name: "xxLargeDesktop",
            type: "string",
            enum: AVATAR_SIZES,
          },
        ],
      },
      {
        name: "icon",
        type: "object",
        subFields: [
          ...BuilderIconConfig,
          {
            name: "position",
            type: "string",
            enum: ["topRight", "bottomRight"],
            defaultValue: "topRight",
          },
          {
            name: "showContainer",
            type: "boolean",
            defaultValue: false,
          },
        ],
      },
    ],
  });
};
